module.exports = __webpack_public_path__ + "img/phone-card-used-bg.3a364dc.png";